import React from 'react'
import map from 'lodash/map'
import { Tooltip } from '@mui/material'
import QueuedOrderRow from './QueuedOrderRow'
import { columnCount, OrdersTab } from './columns'
import { t } from '../../../i18n'
import { OrderGroup as OrderGroupType, OrderRow } from '../types'

const scope = 'orders'

const GroupField = ({
  label,
  children
}: {
  label: string
  children: React.ReactNode
}) => (
  <span className="order-group__field">
    <span className="order-group__label">{label}</span>
    <span className="order-group__value">{children}</span>
  </span>
)

const OrderGroup = ({
  tab,
  orderGroup,
  externalIdLabel
}: {
  tab: OrdersTab
  orderGroup: OrderGroupType
  externalIdLabel: string | null
}) => {
  const { order_id, order_number, phone_number, external_id, queued_orders } =
    orderGroup

  return (
    <>
      <tr className="order-group__line">
        <td colSpan={columnCount(tab)}>
          <div className="order-group__bar">
            {order_id ? (
              <>
                {order_number && (
                  <GroupField label={t('order', { scope })}>
                    <Tooltip title={t('see_details', { scope })}>
                      <a
                        href={`/orders/${order_id}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="order-group__link"
                      >
                        <span>{`#${order_number}`}</span>
                        <i className="fa fa-external-link order-group__link-icon" />
                      </a>
                    </Tooltip>
                  </GroupField>
                )}
                {external_id && (
                  <GroupField
                    label={externalIdLabel || t('external_id', { scope })}
                  >
                    {external_id}
                  </GroupField>
                )}
                {phone_number && (
                  <GroupField label={t('phone', { scope })}>
                    {phone_number}
                  </GroupField>
                )}
              </>
            ) : (
              <span className="order-group__field">
                <span className="order-group__value">
                  {t('technical_order', { scope })}
                </span>
              </span>
            )}
          </div>
        </td>
      </tr>
      {map(queued_orders, (queuedOrderOrCommand: OrderRow) => (
        <QueuedOrderRow
          key={`${queuedOrderOrCommand.record_type}-${queuedOrderOrCommand.id}`}
          tab={tab}
          queuedOrderOrCommand={queuedOrderOrCommand}
        />
      ))}
    </>
  )
}

export default OrderGroup
